module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "pencil",
      "state": _vm.readyForCAP,
      "badge": "badge"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.title')))]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.creatives), function(creative) {
    return [(_vm.isExternalCreative(creative)) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('file-gallery', {
      attrs: {
        "files": _vm.getCreativeExternalPreviews(creative)
      }
    }), _c('div', {
      staticClass: "external-creative-buttons"
    }, [_c('gotu-nav-button', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "iconLeft": "pencil",
        "iconSize": 0.8
      },
      on: {
        "click": function($event) {
          _vm.edit(creative.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.buttons.edit')))])], 1)], 1) : _c('div', {
      staticClass: "col-12"
    }, [_c('creative', {
      attrs: {
        "creative": creative,
        "facebookPage": _vm.facebookPage,
        "showActive": _vm.creatives.length > 1
      }
    })], 1), (_vm.canActAsCustomer && _vm.isCreativeReady(creative)) ? _c('div', {
      staticClass: "col-12 no-padding"
    }, [_c('creative-preview-feedback', {
      attrs: {
        "permissions": _vm.permissions.getPermissions(creative),
        "identificator": ("-" + (creative.id)),
        "toggleElement": ("commentCollapse-" + (creative.id)),
        "noSpacing": true
      },
      on: {
        "approveCreative": function($event) {
          _vm.approveCreative(creative)
        }
      }
    }), _c('b-collapse', {
      attrs: {
        "id": ("commentCollapse-" + (creative.id)),
        "visible": false
      }
    }, [_c('comment', {
      ref: ("comment-reject-" + (creative.id)),
      refInFor: true,
      attrs: {
        "label": _vm.$t("pos.creative.your-campaign-brief"),
        "placeholder": _vm.$t("pos.creative.your-campaign-brief-description"),
        "comment": _vm.commentData(creative)
      }
    }, [_c('div', {
      staticClass: "text-right",
      attrs: {
        "slot": "buttons"
      },
      slot: "buttons"
    }, [_c('gotu-nav-button', {
      attrs: {
        "theme": "default-cta",
        "data-test": "`reject-creative-${creative-id}`"
      },
      on: {
        "click": function($event) {
          _vm.rejectCreative(creative)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('pos.creative.reject')))])], 1)])], 1)], 1) : _vm._e()]
  })], 2)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f66ea17c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-creatives/CampaignCreatives.vue
// module id = 2102
// module chunks = 1